import User from '../models/User'

const isCommon = (user: User) => user && user.roles.length === 0

export default isCommon
